import axios from "axios";
import { Content, ContentSchema, UpsertContentDTO } from "../types/content";
import { toCamelCase, toSnakeCase } from "../utils/objectHelper";
import { CopyScape } from "../types/copyScape";
import { TYTG } from "../types/YTG";
import { TCheckText } from "../types/CheckText";

export const ContentTransport = {
    list: async () => {
        const { data } = await axios.get(`/orders`, {});
        return data.map((current: any) => {
            return ContentSchema.cast(toCamelCase(current), { stripUnknown: true });
        });
    },

    checkCopyScape: async (text: string): Promise<CopyScape> => {
        const { data } = await axios.request({
            method: "post",
            url: "/content/CopyScape",
            data: toSnakeCase({ text }),
        });
        return data;
    },
    checkYTG: async (text: string, guideId: number): Promise<TYTG> => {
        const { data } = await axios.request({
            method: "post",
            url: "/content/YTG",
            data: { text, guideId },
        });
        return data;
    },

    checkText: async (text: string, orderId?: number): Promise<TCheckText> => {
        const { data } = await axios.request({
            method: "post",
            url: "/content/checkText",
            data: { text, orderId },
        });
        return data;
    },

    saveContentInOrder: async (
        content: UpsertContentDTO,
        id: number | undefined
    ): Promise<Content> => {
        const response = await axios.request({
            method: id ? "put" : "post",
            url: id ? `/contentInOrder/${id}` : "/contentInOrder",
            data: toSnakeCase(content),
        });

        return ContentSchema.cast(toCamelCase(response.data), { stripUnknown: true });
    },

    saveReviewedContentInOrder: async (
        content: UpsertContentDTO,
        id: number | undefined
    ): Promise<Content> => {
        const response = await axios.request({
            method: "put",
            url: `/reviewedContentInOrder/${id}`,
            data: toSnakeCase(content),
        });

        return ContentSchema.cast(toCamelCase(response.data), { stripUnknown: true });
    },
    returnText: async (content: UpsertContentDTO) => {
        await axios.request({
            method: "put",
            url: `/content/returnText/${content.id}`,
            data: toSnakeCase(content),
        });
    },

    save: async (content: UpsertContentDTO, id: number | undefined): Promise<Content> => {
        const response = await axios.request({
            method: id ? "put" : "post",
            url: id ? `/content/${id}` : "/content",
            data: toSnakeCase(content),
        });

        return ContentSchema.cast(toCamelCase(response.data), { stripUnknown: true });
    },

    toggleActive: async (object: Content): Promise<void> => {
        await axios.patch(`/content/${object.id}/actions/toggleActive`);
    },

    formTransformer: (
        object: Content,
        rate?: number | null | undefined,
        commentFromProofreader?: string | null | undefined
    ): UpsertContentDTO | object => {
        if (!object) {
            return {};
        }

        return {
            id: object.id,
            thematicId: object.thematic?.id,
            keywords: object.keywords,
            writingType: object.writingType,
            title: object.title,
            metaTitle: object.metaTitle,
            metaDescription: object.metaDescription,
            category: object.category,
            text: object.text,
            wordCount: object.wordCount,
            rate: rate || 0,
            commentFromProofreader,
            images: object.images,
        };
    },
};
